module.exports = __webpack_public_path__ + "assets/img/close-dark.533a4eb1.svg";